module.exports = __webpack_public_path__ + "img/img-eat-08.c3d4e64b.png";